import { createSelector } from "@reduxjs/toolkit";

export const ownerTrackerListState = (state) => state.ownerTrackerReducer;

export const ownerTrackerListSelectors = createSelector(ownerTrackerListState, (state) => state);
